import Cookies from 'js-cookie'
// import Moments from 'moment'

const uar = 'uax'
const uax = 'urx'
const pux = 'pdx'

export function getUrToken () {
  return Cookies.get(uar)
}

export function setUrToken (token) {
  return Cookies.set(uar, token)
}

export function removeUrToken () {
  return Cookies.remove(uar)
}

export function getUxToken () {
  return Cookies.get(uax)
}

export function setUxToken (token) {
  return Cookies.set(uax, token)
}

export function removeUxToken () {
  return Cookies.remove(uax)
}

export function getPuxToken () {
  return Cookies.get(pux)
}

export function setPuxToken (token) {
  return Cookies.set(pux, token)
}

export function removePuxToken () {
  return Cookies.remove(pux)
}

export function setCtrSeq (token) {
  return Cookies.set("ctr", token)
}

export function getCtrSeq () {
  return Cookies.get("ctr")
}
